 <editor *ngIf="props" [(ngModel)]="value" [init]="props" (ngModelChange)="onValueChanges($event)"></editor>